import { Store } from 'vuex'
import uuid from 'uuid/v4'
import SessionIdStorageInterface from './session-id-storage-interface'

class SessionIdStorage implements SessionIdStorageInterface {
  store: Store

  constructor (store) {
    this.store = store
  }

  getSessionId (): string {
    if (this.store.getters['configuration/sessionId'] === null) {
      this.store.dispatch('configuration/setSessionId', this.generateSessionId())
    }
    return this.store.getters['configuration/sessionId']
  }

  clearSessionId (): void {
    this.store.dispatch('configuration/setSessionId', null)
  }

  generateSessionId (): string {
    return uuid()
  }
}

export default SessionIdStorage



// WEBPACK FOOTER //
// ./src/service/session-id-storage.js